import { Inventory as Page } from './Inventory.main';
import { InventoryHeader as Header } from './InventoryHeader';
export { InventoryTable } from './InventoryTable';

export const Inventory = { Header, Page };
